import { z } from "zod";

export const loginInputSchema = z.object({ email: z.string().trim().toLowerCase().pipe(z.email().max(200)), password: z.string().min(1).max(200) });
export type LoginInput = z.infer<typeof loginInputSchema>;

export const userSchema = z.object({ id: z.string(), name: z.string(), email: z.string(), roleLabel: z.string() });
export type User = z.infer<typeof userSchema>;

/** Único lugar que define o tamanho mínimo de senha; API, tela e ajuda leem daqui. */
export const PASSWORD_MIN_LENGTH = 8;
export const changePasswordInputSchema = z
  .object({ currentPassword: z.string().min(1).max(200), newPassword: z.string().min(PASSWORD_MIN_LENGTH, `A nova senha precisa ter pelo menos ${PASSWORD_MIN_LENGTH} caracteres`).max(200) })
  .refine((input) => input.currentPassword !== input.newPassword, { message: "A nova senha precisa ser diferente da atual", path: ["newPassword"] });
export type ChangePasswordInput = z.infer<typeof changePasswordInputSchema>;
